import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import { sf_hinhthucmiengiam } from "../../../models/response/hinh-thuc-mien-giam/sf_hinhthucmiengiam";

export const objHinhThucMienGiamDefine = {
  LOAD_START: { nam_hoc: "" as string, dm_coso_id: 0 },
  LOAD_SUCCESS: [] as sf_hinhthucmiengiam[],
  LOAD_ERROR: "",

  SAVE_START: {} as sf_hinhthucmiengiam,
  SAVE_SUCCESS: {} as sf_hinhthucmiengiam,
  SAVE_ERROR: "",

  DELETE_START: [] as number[],
  DELETE_SUCCESS: undefined as void,
  DELETE_ERROR: "",

  SHOW_DETAIL_MODAL: {} as sf_hinhthucmiengiam | undefined,
  CLOSE_DETAIL_MODAL: undefined as void,

  SHOW_DELETE_CONFIRM: undefined as void,
  CLOSE_DELETE_CONFIRM: undefined as void,

  CHANGE_SELECTION_IDS: [] as number[],
  CHANGE_NAM_HOC: "" as string,
};

export const eHinhThucMienGiamActionTypeIds = generateActionTypeIds(
  objHinhThucMienGiamDefine,
  "HINH_THUC_MIEN_GIAM"
);
export type IHinhThucMienGiamActionTypes = IGenericActionType<
  typeof objHinhThucMienGiamDefine,
  "HINH_THUC_MIEN_GIAM"
>;


